import React from 'react'
import { useTranslation } from 'react-i18next'
import { Container, Header, Button } from 'semantic-ui-react'
import "./Section1.css"

const Section1 = () => {
    const { t } = useTranslation()
    return <div className="Section1 main-bg">
        <div className="d-flex flex-column align-items-center justify-content-center  p-15-b">
            <Header inverted as="h1" className="m-8-t text-center">{t("home:NotSureWhereToGo")} <br></br>{t("home:Perfect")}</Header>
            <Button inverted className="rounded-50" size='big'>
                {t("home:IAmFlexible")}
            </Button>
        </div>
    </div>
}
export default Section1